import { render, staticRenderFns } from "./VisualizarTraspasosView.vue?vue&type=template&id=33258397&"
import script from "./VisualizarTraspasosView.vue?vue&type=script&lang=js&"
export * from "./VisualizarTraspasosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports